import { DefaultButton } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import styles from "./LoginButton.module.css";
import { useAuth } from "../../contexts/AuthContext";

export const LoginButton = () => {
    const { user, isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleLogin = () => {
        navigate("/login");
    };

    const handleLogout = async () => {
        await logout();
        navigate("/login");
    };

    const displayName = user?.email || user?.username || "";

    return (
        <DefaultButton
            text={isAuthenticated ? `${t("logout")}\n${displayName}` : `${t("login")}`}
            className={styles.loginButton}
            onClick={isAuthenticated ? handleLogout : handleLogin}
        />
    );
};
